import React from 'react';
import './HorizontalSeparator.scss';

export interface HorizontalSeparatorArgs {
  className?: string;
}
export const HorizontalSeparator = ({ className }: HorizontalSeparatorArgs): JSX.Element => {
  return <div className={`syte-horizontal-separator ${className}`} />;
};
